import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../../headerone/Main'


function RTISection4AdministrationEle6Pg() {
    return(
        <>
            
                <div className='container'>
                            <div className='ms-3'>
                                <h4>E-Governance</h4>
                            
                                <table className="table table-striped">
                                <tbody>
                                <tr>
                                <td>
                                <strong>S. No.</strong>
                                </td>
                                <td >
                                <strong>Item</strong>
                                </td>
                                <td >
                                <strong>Details</strong>
                                </td>
                                </tr>
                                <tr>
                                <td>
                                <strong>4.1</strong>
                                </td>
                                <td colspan="2">
                                <strong>Language in which information Manual / Handbook Available [F.No.1/6/2011-IR dt.15.4.2013]</strong>
                                </td>
                                </tr>
                                <tr>
                                <td>
                                4.1.1
                                </td>
                                <td>
                                English
                                </td>
                                <td>
                                Annual Reports<br />
                                The Institutes of Technology Act, 1961<br />
                                The Institutes of Technology (Amendment) Act, 2016<br />
                                Statutes of IIT Tirupati
                                </td>
                                </tr>
                                <tr>
                                <td>
                                4.1.2&nbsp;
                                </td>
                                <td>
                                Vernacular / Local Language
                                </td>
                                <td>
                                NIL
                                </td>
                                </tr>
                                <tr>
                                <td>
                                <strong>4.2</strong>
                                </td>
                                <td colspan="2">
                                <strong>When was the information Manual / Handbook last updated? [F.No.1/6/2011-IR dt. 15.4.2013]</strong>
                                </td>
                                </tr>
                                <tr>
                                <td>
                                4.2.1
                                </td>
                                <td>
                                Last date of Annual updation
                                </td>
                                <td>
                                31 October 2023
                                </td>
                                </tr>
                                <tr>
                                <td>
                                <strong>4.3</strong>
                                </td>
                                <td colspan="2">
                                <strong>Information available in electronic form [Section 4(1)(b)(xiv)]</strong>
                                </td>
                                </tr>
                                <tr>
                                <td>
                                4.3.1
                                </td>
                                <td>
                                Details of information available in electronic form
                                </td>
                                <td>
                                <a className="c-link" href="https://iittp.ac.in/">https://iittp.ac.in/</a>
                                </td>
                                </tr>
                                <tr>
                                <td>
                                4.3.2
                                </td>
                                <td>
                                Name / title of the document / record / other information
                                </td>
                                <td>
                                <a className="c-link" href="https://iittp.ac.in/">https://iittp.ac.in/</a> (Annual reports, Statements of account, tender Notice ordinance etc.,)
                                </td>
                                </tr>
                                <tr>
                                <td>
                                4.3.3
                                </td>
                                <td>
                                Location where available
                                </td>
                                <td>
                                <a className="c-link" href="https://iittp.ac.in/">https://iittp.ac.in/</a>
                                </td>
                                </tr>
                                <tr>
                                <td>
                                <strong>4.4</strong>
                                </td>
                                <td colspan="2">
                                <strong>Particulars of facilities available to citizen for obtaining information [Section 4(1) (b)(xv)</strong>
                                </td>
                                </tr>
                                <tr>
                                <td>
                                4.4.1
                                </td>
                                <td>
                                Name &amp; location of the facility
                                </td>
                                <td>
                                <a className="c-link" href="https://iittp.ac.in/">https://iittp.ac.in/</a>
                                </td>
                                </tr>
                                <tr>
                                <td>
                                4.4.2
                                </td>
                                <td>
                                Details of information made available
                                </td>
                                <td>
                                <a className="c-link" href="https://rti.gov.in/">RTI Online/</a> Institute Portal having CPIO Contact details as well as various details of academic &amp; Administrative information of the Institute)
                                </td>
                                </tr>
                                <tr>
                                <td>
                                4.4.3
                                </td>
                                <td>
                                Working hours of the facility
                                </td>
                                <td>
                                Monday-Friday (9.00 a.m. - 5.30 p.m. including 30 min. Lunch Break.)
                                </td>
                                </tr>
                                <tr>
                                <td>
                                4.4.4
                                </td>
                                <td>
                                Contact person &amp; contact details (Phone, fax email)
                                </td>
                                <td>
                                <a className="c-link" href="https://iittp.ac.in/contact-iit">https://iittp.ac.in/contact-iit</a>
                                </td>
                                </tr>
                                <tr>
                                <td>
                                <strong>4.5</strong>
                                </td>
                                <td colspan="2">
                                <strong>Such other information as may be prescribed under Section 4(i)(b)(xvii)</strong>
                                </td>
                                </tr>
                                <tr>
                                <td>
                                4.5.1
                                </td>
                                <td>
                                Grievance redressal mechanism
                                </td>
                                <td>
                                <a className="c-link" href="https://iittp.ac.in/liaison-officers">https://iittp.ac.in/liaison-officers</a>
                                </td>
                                </tr>
                                <tr>
                                <td>
                                4.5.2
                                </td>
                                <td>
                                Details of applications received under RTI and information provided
                                </td>
                                <td><br />
                                <table className="rti">
                                <tbody>
                                <tr>
                                <td>
                                Financial Year
                                </td>
                                <td>
                                RTIs received
                                </td>
                                <td>
                                RTIs replied
                                </td>
                                </tr>
                                <tr>
                                <td>
                                2020-21
                                </td>
                                <td>
                                76
                                </td>
                                <td>
                                76
                                </td>
                                </tr>
                                <tr>
                                <td>
                                2021-22
                                </td>
                                <td>
                                159
                                </td>
                                <td>
                                159
                                </td>
                                </tr>
                                <tr>
                                <td>
                                2022-23
                                </td>
                                <td>
                                142
                                </td>
                                <td>
                                142
                                </td>
                                </tr>
                                <tr>
                                <td>
                                2023-24
                                </td>
                                <td>
                                166
                                </td>
                                <td>
                                166
                                </td>
                                </tr>
                                </tbody>
                                </table>
                                </td>
                                </tr>
                                <tr>
                                <td>
                                4.5.3
                                </td>
                                <td>
                                List of completed schemes / projects / Programmes
                                </td>
                                <td>
                                Not Applicable
                                </td>
                                </tr>
                                <tr>
                                <td>
                                4.5.4
                                </td>
                                <td>
                                List of schemes / projects / programme underway
                                </td>
                                <td>
                                Not Applicable 
                                </td>
                                </tr>
                                <tr>
                                <td>
                                4.5.5
                                </td>
                                <td>
                                Details of Contracts entered into including name of the contractor, amount of contract and period of completion of contract
                                </td>
                                <td>
                                IIT Tirupati website: <a className="c-link" href="https://iittp.ac.in/tenders">https://iittp.ac.in/tenders</a>
                                Central Public Procurement Portal
                                <strong>Indian Institute of Technology Tirupati</strong>
                                <p >Active Tenders: <a className="c-link" href="https://eprocure.gov.in/eprocure/app?page=FrontEndTendersByOrganisation&amp;service=page">https://eprocure.gov.in/eprocure/app?page=FrontEndTendersByOrganisation&amp;service=page</a>
                                </p><p >Tender Status: <a className="c-link" href="https://eprocure.gov.in/eprocure/app?page=WebTenderStatusLists&amp;service=page">https://eprocure.gov.in/eprocure/app?page=WebTenderStatusLists&amp;service=page</a>
                                </p><p >Finalized Tenders: <a className="c-link" href="https://eprocure.gov.in/eprocure/app?page=ResultOfTenders&amp;service=page">https://eprocure.gov.in/eprocure/app?page=ResultOfTenders&amp;service=page</a>
                                </p><p >Archived Tenders: <a className="c-link" href="https://eprocure.gov.in/eprocure/app?page=FrontEndTendersInArchive&amp;service=page">https://eprocure.gov.in/eprocure/app?page=FrontEndTendersInArchive&amp;service=page</a>
                                </p></td>
                                </tr>
                                <tr>
                                <td>
                                4.5.6
                                </td>
                                <td>
                                Annual Report
                                </td>
                                <td>
                                <a className="c-link" href="https://iittp.ac.in/annualreports">https://iittp.ac.in/annualreports</a>
                                </td>
                                </tr>
                                <tr>
                                <td>
                                4.5.7
                                </td>
                                <td>
                                Frequently Asked Question (FAQs)
                                </td>
                                <td>
                                <a className="c-link" href="https://iittp.ac.in/faqs">https://iittp.ac.in/faqs</a>
                                </td>
                                </tr>
                                <tr>
                                <td>
                                4.5.8
                                </td>
                                <td>
                                Any other information such as - (a) Citizen’s Charter, (b) Result Framework Document (RFD), (c) Six monthly reports on the, (d) Performance against the benchmarks set in the Citizen’s Charter
                                </td>
                                <td>
                                Not applicable
                                </td>
                                </tr>
                                <tr>
                                <td>
                                <strong>4.6</strong>
                                </td>
                                <td colspan="2">
                                <strong>Receipt &amp; Disposal of RTI applications &amp; appeals [F.No.1/6/2011-IR dt.15.4.2013]</strong>
                                </td>
                                </tr>
                                <tr>
                                <td>
                                4.6.1
                                </td>
                                <td>
                                Details of applications received and disposed
                                </td>
                                <td><br />
                                <table className="rti">
                                <tbody>
                                <tr>
                                <td>
                                Financial Year
                                </td>
                                <td>
                                RTIs received
                                </td>
                                <td>
                                RTIs replied
                                </td>
                                </tr>
                                
                                <tr>
                                <td>
                                2020-21
                                </td>
                                <td>
                                76
                                </td>
                                <td>
                                76
                                </td>
                                </tr>
                                <tr>
                                <td>
                                2021-22
                                </td>
                                <td>
                                159
                                </td>
                                <td>
                                159
                                </td>
                                </tr>
                                <tr>
                                <td>
                                2022-23
                                </td>
                                <td>
                                142
                                </td>
                                <td>
                                142
                                </td>
                                </tr>
                                <tr>
                                <td>
                                2023-24
                                </td>
                                <td>
                                166     
                                </td>
                                <td>
                                166
                                </td>
                                </tr>
                                </tbody>
                                </table>
                                </td>
                                </tr>
                                <tr>
                                <td>
                                4.6.2
                                </td>
                                <td>
                                Details of appeals received and orders issued
                                </td>
                                <td><br />
                                <table className="rti">
                                <tbody>
                                <tr>
                                <td>
                                Financial Year
                                </td>
                                <td>
                                RTI Appeals received
                                </td>
                                <td>
                                RTI Appeals replied
                                </td>
                                </tr>
                                
                                <tr>
                                <td>
                                2020-21
                                </td>
                                <td>
                                5
                                </td>
                                <td>
                                5
                                </td>
                                </tr>
                                <tr>
                                <td>
                                2021-22
                                </td>
                                <td>
                                16
                                </td>
                                <td>
                                16
                                </td>
                                </tr>
                                <tr>
                                <td>
                                2022-23
                                </td>
                                <td>
                                10
                                </td>
                                <td>
                                10
                                </td>
                                </tr>
                                <tr>
                                <td>
                                2023-24
                                </td>
                                <td>
                                18
                                </td>
                                <td>
                                18
                                </td>
                                </tr>
                                </tbody>
                                </table>
                                </td>
                                </tr>
                                <tr>
                                <td>
                                <strong>4.7</strong>
                                </td>
                                <td colspan="2">
                                <strong>Replies to question asked in the parliament [Section 4(1)(d)(2)]</strong>
                                </td>
                                </tr>
                                <tr>
                                <td>
                                4.7.1
                                </td>
                                <td>
                                Details of questions asked and replies given
                                </td>
                                <td>
                                <a className="c-link" href="https://files.iittp.ac.in/pdfs/rti/Parliament Questions and Answers.pdf">Replies for Parliamentary questions </a>
                                </td>
                                </tr>
                                </tbody>
                                </table>
                            
                            </div>
                    </div> 
            
        </>
    );
}

export default RTISection4AdministrationEle6Pg;